import type { IChatSession, IChatMessage } from '@/types/chat-session-types'

// Frontend specific extensions of domain types
export interface IChatMessageWithState extends IChatMessage {
  status?: 'sending' | 'sent' | 'failed'
  id: string
  replyToId?: string // ID of the message this is replying to (for threading and retry functionality)
}

export interface IChatSessionWithState extends IChatSession {
  messages: IChatMessageWithState[]
  createdAt: Date
  lastActivity: Date
  isActive: boolean
  metadata?: Record<string, unknown>
}

export const SESSION_DATE_FIELDS = [
  'createdAt',
  'lastActivity',
  'startedAt',
  'endedAt',
] as const

export interface IChatSessionState {
  chatbotId: string

  // Sessions management
  sessions: Record<string, IChatSessionWithState>
  activeSessionId: string | null

  // Global state
  isLoading: boolean
  isCreatingSession: boolean
  isTyping: boolean
  isConnected: boolean
  error: string | null
  isInitialized: boolean
  lastLoaded: Date | null

  // Configuration
  persistMessages: boolean
  autoScrollToBottom: boolean
}
